import { Map, List } from 'immutable';
import _ from 'lodash';

import trainTime from '../lib/TrainTime';


let _linkMap = new Map();

const _isLink = (value) => _.isString(value) && value.charAt(0) === '/';

const _applier = (oldValue, newValue, func) => {
    return oldValue ? func(newValue) : oldValue;
};

const _deserializer = (oldValue, newValue, Type) => {
    if (_.isUndefined(oldValue) || _.isNull(oldValue)) { return oldValue; }
    let result = Type.fromJSON(newValue);
    if (_isLink(oldValue) && !result.get('id') && result.has('id')) { result = result.set('id', oldValue); }
    return result;
};

export function construct (Type, values = {}, schema = {}) {
    const resolved = Object.keys(schema).reduce((reduction, key) => {
        const factory = schema[key];
        if (typeof factory === 'function') {
            reduction[key] = factory(values[key]);
        } else {
            reduction[key] = factory;
        }
        return reduction;
    }, {});
    return new Type(resolved);
}

export function resolve (key) {
    let resolved;

    if (_isLink(key)) {
        resolved = _linkMap.get(key, null);
        if (!resolved) { console.warn(`No link found for "${ key }"`); }
    }

    // In anycase return what was given
    if (!resolved) { resolved = key; }

    return {
        as: _.partial(_deserializer, key, resolved),
        with: _.partial(_applier, key, resolved)
    };
}

resolve.as = function (Type) {
    return function (value) { return resolve(value).as(Type); };
};

resolve.with = function (func) {
    return function (value) { return resolve(value).with(func); };
};

export const fields = {
    string: resolve.with(String),
    bool: resolve.with(Boolean),
    boolean: resolve.with(Boolean),
    number: resolve.with(Number),
    datetime: resolve.with(trainTime),
    duration: resolve.with(trainTime.duration),
    identity: resolve.with(_.identity),
};

export function resolveAll (keys, Collection = List) {
    const list = new Collection(keys);
    const resolved = list.map((key) => resolve(key));

    return {
        as: (Type) => resolved.map((item) => item.as(Type)),
        with: (func) => resolved.map((item) => item.with(func))
    };
}

resolveAll.as = function (Type, Collection) {
    return function (value) { return resolveAll(value, Collection).as(Type); };
};

resolveAll.with = function (func, Collection) {
    return function (value) { return resolveAll(value, Collection).with(func); };
};

export function resolveMap (values) {
    return resolveAll(values, Map);
}

resolveMap.as = (Type) => resolveAll.as(Type, Map);

resolveMap.with = (Type) => resolveAll.with(Type, Map);

export function addLinks (links) {
    _linkMap = _.reduce(links, (acc, linkValue, linkKey) => {
        return acc.set(linkKey, linkValue);
    }, _linkMap);

    return _linkMap;
}

export function getLinks () {
    return _linkMap;
}

export function clearLinks () {
    _linkMap = _linkMap.clear();
    return _linkMap;
}

export default {
    clearLinks,
    getLinks,
    addLinks,
    resolve,
    resolveAll
};



// WEBPACK FOOTER //
// ./src/helpers/LinkMapper.js